import { ResourceItem } from "../../../components/Layout/Items/ResourceItem";
import { Resource } from "../../../types/resource";
import { useSpaceContext } from "../../../contexts/AppDataContext";
import KnowledgeTracker from "./KnowledgeTracker";
import { Upload03Icon } from "hugeicons-react";
import { useAttachmentContext } from "../../../contexts/AttachmentContext";
import { TextFileRecord } from "../../../types/files";

interface AttachmentsListProps {
  attachments: Resource[];
  /** Opens a saved resource (not an uploaded material). */
  handleResourceClick: (resource: Resource) => void;
  /** Removes an uploaded material. */
  handleAttachmentRemove: (attachment: Resource) => void;
}

export const AttachmentsList: React.FC<AttachmentsListProps> = ({
  attachments,
  handleResourceClick,
  handleAttachmentRemove,
}) => {
  const { currentSpace } = useSpaceContext();
  const { setTextViewerState } = useAttachmentContext();

  const handleAttachClick = (attachment: Resource) => {
    // Uploaded materials always open in the viewer; clicking one must never
    // remove it (only the row's delete control does).
    if (attachment.isTextAttachment) {
      const file: TextFileRecord = {
        id: attachment.id,
        name: attachment.title,
        size: 0,
        url: attachment.url || "",
        content: attachment.content ?? null,
        isLoaded: true,
        type: attachment.type as TextFileRecord["type"],
      };
      setTextViewerState({
        isOpen: true,
        file: file,
      });
    } else {
      handleResourceClick(attachment);
    }
  };

  return (
    <div className="attachments-list-container">
      <KnowledgeTracker knowledgeCount={currentSpace?.knowledgeCount || 0} />
      {attachments.length > 0 ? (
        <div className="attachments-list">
          {attachments.map((attachment) => (
            <ResourceItem
              key={attachment.id}
              resource={attachment}
              onClick={() => handleAttachClick(attachment)}
              onDelete={attachment.isTextAttachment ? () => handleAttachmentRemove(attachment) : undefined}
            />
          ))}
        </div>
      ) : (
        <div className="empty-files-state">
          <div className="empty-state-icon">
            <Upload03Icon size={32} />
          </div>
          <h3>No Materials Yet</h3>
          <p>Upload documents to enhance your learning experience</p>
        </div>
      )}
    </div>
  );
};
